import React from "react";

import {
  MapNavSection,
  MapRecentSection,
  ModuleMenu,
  type ModuleMenuSection,
  useVisibleRecentMapPlaces,
} from "#app/components/navigation/module-menu";

/**
 * The Map module menu: the Live Map destination, then the viewer's recent
 * places. Recent is dropped from the section list while empty so ModuleMenu
 * draws no stray divider under the one nav row (the section also renders
 * nothing then, the module-menu recents grammar).
 */
export function MapModuleMenu() {
  const { places } = useVisibleRecentMapPlaces();
  const hasRecent = places.length > 0;
  const sections = React.useMemo<ModuleMenuSection[]>(() => {
    const list: ModuleMenuSection[] = [
      { id: "nav", Component: MapNavSection },
    ];
    if (hasRecent) list.push({ id: "recent", Component: MapRecentSection });
    return list;
  }, [hasRecent]);

  return <ModuleMenu title="Map" sections={sections} />;
}
